import { forwardRef } from 'react';
import { translate } from '../../../helpers';
import { useDueDateTimezone } from '../../../hooks';
import { Rfi } from '../../../sdk';
import { CommonFormField, CommonFormFieldProps } from '../CommonFormField';
import { DueDateInfoPopover } from './DueDateInfoPopover';

export type DueDateFormFieldProps = Omit<CommonFormFieldProps, 'renderInfoPopover' | 'label'> & {
  rfiCreatedAt: Rfi['createdAt'];
  'data-testId'?: string;
};

const renderInfoPopover: CommonFormFieldProps['renderInfoPopover'] = (props) => (
  <DueDateInfoPopover {...props} />
);

export const DueDateFormField = forwardRef<HTMLDivElement, DueDateFormFieldProps>(
  (
    { 'data-testId': dataTestId = 'DueDateFormField', rfiCreatedAt, ...commonFormFieldProps },
    ref,
  ) => {
    const { dueDateTimeZone } = useDueDateTimezone(rfiCreatedAt);

    return (
      <CommonFormField
        label={translate('date.fields.dueDate')}
        data-testid={dataTestId}
        ref={ref}
        {...(dueDateTimeZone && { renderInfoPopover })}
        {...commonFormFieldProps}
      />
    );
  },
);
